<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {allTokens, ligamentInfo, updateLigament} from 'src/components/cabinet/#services/cryptoMarket'

    export let id

    ligamentInfo.reset()
    ligamentInfo.send({ data: { id: +id } })

    let currentPage = 0
    let perPage = 999

    allTokens.reset()
    allTokens.send({ data: { page: currentPage + 1, perPage } })

    let saved = false
    let swapInfo

    $: if (!swapInfo && $ligamentInfo.hasValue) {
        swapInfo = $ligamentInfo.value && JSON.parse(JSON.stringify($ligamentInfo.value))
    }

    async function save() {
        if (!swapInfo.description) delete swapInfo.description
        delete swapInfo.createdAt
        delete swapInfo.updatedAt
        delete swapInfo.priorityIndex
        delete swapInfo.disabled

        saved = true

        try {
            updateLigament.send({ data: swapInfo })

            showAlert.set({
                status: 'success',
                text: 'Ligament successfully updated!'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }
</script>

<svelte:head>
    <title>Edit Swap</title>
</svelte:head>

<MainLayout title="Edit Swap">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <Link to="swap" class="btn btn-primary mb-3">Back</Link>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        {#if $ligamentInfo.loading}
                            Loading...
                        {:else if $ligamentInfo.error || !$ligamentInfo.hasValue}
                            An error has occurred
                        {:else if $ligamentInfo.value && swapInfo}
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group mb-3">
                                        <label>Token 1</label>
                                        <select class="form-select" bind:value={swapInfo.firstToken} disabled={!$allTokens.hasValue}
                                                class:is-invalid={saved && swapInfo?.firstToken === ''}>
                                            {#if !$allTokens.hasValue && $allTokens.loading}
                                                <option value="">Loading...</option>
                                            {:else if $allTokens.error}
                                                <option value="">Error</option>
                                            {:else if $allTokens.hasValue}
                                                <option hidden value="">Select token</option>
                                                {#each $allTokens.value.data as { name }}
                                                    {#if swapInfo.secondToken !== name}
                                                        <option value={name}>{name}</option>
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </select>
                                    </div>
                                    <div class="form-group mb-3">
                                        <label>Pool {#if swapInfo?.firstToken}{swapInfo.firstToken}{:else}1{/if}</label>
                                        <input type="number" class="form-control" bind:value={swapInfo.firstPool}
                                            class:is-invalid={saved && swapInfo && swapInfo.firstPool === ''}>
                                    </div>
                                    <div class="form-group mb-3">
                                        <label>Fee {#if swapInfo?.firstToken}{swapInfo.firstToken}{:else}1{/if} (%)</label>
                                        <input type="number" class="form-control" bind:value={swapInfo.firstFee}
                                            class:is-invalid={saved && swapInfo && swapInfo.firstFee === ''}>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group mb-3">
                                        <label>Token 2</label>
                                        <select class="form-select" bind:value={swapInfo.secondToken} disabled={!$allTokens.hasValue}
                                                class:is-invalid={saved && swapInfo?.secondToken === ''}>
                                            {#if !$allTokens.hasValue && $allTokens.loading}
                                                <option value="">Loading...</option>
                                            {:else if $allTokens.error}
                                                <option value="">Error</option>
                                            {:else if $allTokens.hasValue}
                                                <option hidden value="">Select token</option>
                                                {#each $allTokens.value.data as { name }}
                                                    {#if swapInfo?.firstToken !== name}
                                                        <option value={name}>{name}</option>
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </select>
                                    </div>
                                    <div class="form-group mb-3">
                                        <label>Pool {#if swapInfo?.secondToken}{swapInfo.secondToken}{:else}2{/if}</label>
                                        <input type="number" class="form-control" bind:value={swapInfo.secondPool}
                                            class:is-invalid={saved && swapInfo?.secondPool === ''}>
                                    </div>
                                    <div class="form-group mb-3">
                                        <label>Fee {#if swapInfo?.secondToken}{swapInfo.secondToken}{:else}2{/if} (%)</label>
                                        <input type="number" class="form-control" bind:value={swapInfo.secondFee}
                                            class:is-invalid={saved && swapInfo?.secondFee === ''}>
                                    </div>
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>
                <button class="btn btn-success" on:click={save}
                    disabled={!swapInfo || !swapInfo?.firstToken || !swapInfo.secondToken || !swapInfo.firstPool || !swapInfo.secondPool}>
                    Save
                </button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>
